import { generatePath, useParams } from 'react-router-dom';

import { Card, CardHeader } from '@mui/material';

import { useNavigateAfterSubmit } from 'common/hooks';
import { addDuration } from 'common/utils';

import { LoadingIndicator } from 'commonComponents/LoadingIndicator';
import { PageContainer } from 'commonComponents/PageContainer';

import { createLicenseFile, useLicense } from 'api/licenses';
import { CreateIcon } from 'icons/CreateIcon';
import { calcExpirationDate, getNumberOfMacAddresses, PLATFORMS } from 'licenses/utils';
import { ROUTES } from 'routes/routes';

import { LicenseFileForm } from './LicenseFileForm';

export function CreateLicenseFile() {
    const navigateAfterSubmit = useNavigateAfterSubmit();
    const { licenseId } = useParams<{ licenseId: string }>();

    const response = useLicense(Number(licenseId));
    const { data: license, error } = response;

    if (error) {
        return null;
    }

    if (!license) {
        return <LoadingIndicator />;
    }

    const expirationDate = calcExpirationDate(new Date(), license.configuration);
    const supportExpirationDate = addDuration(
        new Date(),
        license.configuration.supportValidity,
        license.configuration.supportValidityUnit
    );

    const initialValues = {
        expiration_date: expirationDate,
        support_expiration_date: supportExpirationDate,
        license: license.id,
        system_id: null,
        license_can_sign_files: false,
        comment: '',
    };

    const numberOfMacAddresses = getNumberOfMacAddresses(license.configuration);
    for (let index = 0; index < numberOfMacAddresses; index++) {
        initialValues[`mac_address_${index}`] = '';
    }
    Object.entries(PLATFORMS).forEach(([k, _v]) => {
        initialValues[`platform_${k}`] = true;
    });

    return (
        <PageContainer>
            <Card>
                <CardHeader title={'Activate License'} />
                <LicenseFileForm
                    isNewLicenseFile
                    cancelButtonRoute={generatePath(ROUTES.LICENSE_DETAIL, { id: licenseId })}
                    navigate={navigateAfterSubmit}
                    license={license}
                    submitButtonIconClass={CreateIcon}
                    submitButtonText="Activate"
                    submitApiCall={createLicenseFile}
                    disabledFields={['license']}
                    {...{ initialValues }}
                />
            </Card>
        </PageContainer>
    );
}
